import srpFlightResultsApi from '@/src/api/rtkQuery/srpFlightResults'
import type { AppDispatch } from '@/src/redux/store'
import { SearchResponse } from '@/src/types/flight'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import useGetSearchQueryURL from '../getSearchQueryURL'

/**
 * this hook is used to update the search result cache
 */
const useUpdateSearchResultCache = () => {
    const { query, error: pastDateError } = useGetSearchQueryURL()

    const dispatch = useDispatch<AppDispatch>()

    // The returned function takes a callback to update the cache
    const updateCache = useCallback(
        (updater: (currentData: SearchResponse | undefined) => SearchResponse) => {
            if (pastDateError || !query) {
                return
            }
            dispatch(srpFlightResultsApi.util.updateQueryData('getSrpResults', { query }, updater))
        },
        [dispatch, query, pastDateError]
    )

    return updateCache
}

export default useUpdateSearchResultCache
